const throttle = require('throttle-debounce/throttle');
const paritclesConfig = require('./config.yaml')['particleOptions'];
const CBm = require('../../index.js');

class CBm_ru extends CBm {
	constructor() {
		super();

	}

	init() {
		this.$bm = $('.bm');

		if (this.$bm.length) {
			this.paritclesConfig = paritclesConfig;
			const $cols = $('.js-bm-col-align');

			if ($cols.length) {
				// const itemsByRow = this.detectRow($cols);
				// this.alignIt(itemsByRow);

				AR.events.on('svgRenderedAll', () => {
					const itemsByRow = this.detectRow($cols);
					this.alignIt(itemsByRow);
				});

				$(window).on('resize', () => {
					const itemsByRow = this.detectRow($cols);
					this.alignIt(itemsByRow);
				});
			}

			this.initKeyParticles();
			this.removeKi();
		}
	}

	alignIt(itemsArr) {
		itemsArr.forEach(rowItems => {
			let highest = 0;

			rowItems.forEach(elem => {
				const height = $(elem).children('.js-bm-col-inner').height();

				if (height > highest) {
					highest = height;
				}
			});

			$(rowItems).height(highest);
		});
	}

	removeKi() {
		AR.events.on('onKiAnimated', $elem => {
			$elem.closest('.b-indicator__value').find('.b-indicator__value-hidden').remove();
			$elem.closest('.b-indicator__value').find('.b-indicator__value-main').removeClass('b-indicator__value-main');
		});
	}

	detectRow($cols) {
		const itemsByRow = [];
		const colsLength = $cols.length;
		let currentTop = $cols.eq(0).offset().top;
		let levelArr = [];

		$cols.each((i, elem) => {
			const $elem = $(elem);

			if ($elem.offset().top == currentTop) {
				levelArr.push(elem);
			} else {
				itemsByRow.push(levelArr);
				levelArr = [];
				levelArr.push(elem);
				currentTop = $elem.eq(0).offset().top;
			}
		});

		itemsByRow.push(levelArr);

		return itemsByRow;
	}

	initKeyParticles() {
		const $particles = $('.js-bm-particles');

		if ($particles.length) {
			$particles.each((i, elem) => {
				const $elem = $(elem);
				const id = $elem.attr('id');

				if (id) {
					particlesJS(id, this.paritclesConfig);
				}
			});

			$(window).on('resize', throttle(100, () => {
				this.updateParticles();
			}));
		}
	}

	updateParticles() {
		window.pJSDom[0].pJS.fn.particlesRefresh();
	}
}

AR.waitComponents([], () => {
	const cBm_ru = new CBm_ru;

	cBm_ru.init();

	AR.pushComponent(cBm_ru, 'cBm_ru');
});



// WEBPACK FOOTER //
// ./temp/components/bm/.variant/ru/index.js